import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import img1 from "../images/facebook.png";
import img2 from "../images/instagram.png";
import img3 from "../images/youtube.png";
import img4 from "../images/twitter.png";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Footer Top Section */}
        <div className="footer-top">
          <div className="footer-column">
            <h3 className="footer-title">மக்கள் சிந்தனைப் பேரவை</h3>
            <p className="footer-about">
              இலக்கியம் மற்றும் கலாச்சாரத்தின் மூலம் சமூக மாற்றத்தை ஏற்படுத்தும்
              நோக்கத்துடன் இயங்கும் அமைப்பு
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">விரைவு இணைப்புகள்</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">முகப்பு</Link>
              </li>
              <li>
                <Link to="/about">எங்களைப் பற்றி</Link>
              </li>
              <li>
                <Link to="/events">நிகழ்வுகள்</Link>
              </li>
              {/* <li>
                <Link to="/gallery">புகைப்படத் தொகுப்பு</Link>
              </li> */}
              <li>
                <Link to="/contact">தொடர்புக்கு</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">தொடர்புக்கு</h3>
            <ul className="footer-contact">
              <li>
                <i className="fas fa-map-marker-alt"></i> A-47, சம்பத் நகர்,
                ஈரோடு - 638 011.
              </li>
              <li>
                <i className="fas fa-envelope"></i> stalin_guna@yahoo.com
              </li>
              <li>
                <i className="fas fa-phone"></i> 0424 2269186
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">சமூக வலைப்பின்னல்கள்</h3>
            <div className="social-links">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/share/16gTkLiZqt/"
                aria-label="Facebook"
              >
                <img src={img1} className="socialicons" alt="Facebook" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/makkalsinthanaiperavai?igsh=MTh4OXpsYzFidGczZQ=="
                aria-label="Instagram"
              >
                <img src={img2} className="socialicons" alt="Instagram" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://youtube.com/@makkalsinthanaiperavai?feature=shared"
                aria-label="YouTube"
              >
                <img src={img3} className="socialicons" alt="YouTube" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://x.com/Makkalsinthanai?t=FrfS33rgLjff6ZcnbYCaWg&s=08 "
                aria-label="Twitter"
              >
                <img src={img4} className="socialicons" alt="Twitter" />
              </a>
            </div>
            <div className="newsletter">
              <h4>Newsletter</h4>
              <form>
                <input type="email" placeholder="உங்கள் மின்னஞ்சல்" required />
                <button type="submit">பதிவு செய்க</button>
              </form>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <div className="copyright">
            &copy; {new Date().getFullYear()} மக்கள் சிந்தனைப் பேரவை. அனைத்து
            உரிமைகளும் பாதுகாக்கப்பட்டுள்ளன.
          </div>
          <div className="footer-menu">
            <Link to="/privacy-policy">தனியுரிமைக் கொள்கை</Link>
            <Link to="/termsandconditions">பயன்பாட்டு விதிமுறைகள்</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
